export default "__VITE_ASSET__CiFhd2xH__"